import { toast } from "react-toastify";
import useFetch from "../../../hooks/useFetch";
import { getUserId } from "../../../utils/auth";

export const useUploadVideo = (setProfileData) => {
  const userId = getUserId();

  const { mutate: deleteVideo, loading: deleteVideoLoading } = useFetch(
    "/mentor/profile",
    {
      method: "post",
      manual: true,
      data: { mentorId: userId, action: "delete_video" },
      onSuccess: () => {
        toast.success("Video deleted!", {
          position: toast.POSITION.TOP_CENTER,
        });
        setProfileData((prev) => ({ ...prev, videoUrl: null }));
      },
      onError: () => {
        toast.error("Error occured while deleting video", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
    }
  );

  const { mutate: uploadVideo, loading: uploadVideoLoading } = useFetch(
    "/mentor/profileVideo",
    {
      method: "post",
      manual: true,
      confg: { headers: { "Content-Type": "multipart/form-data" } },
      onSuccess: (data) => {
        toast.success("Profile Video Upload", {
          position: toast.POSITION.TOP_CENTER,
        });
        setProfileData((prev) => ({ ...prev, videoUrl: data?.videoUrl }));
      },
      onError: () => {
        toast.error("Profile Video upload failed", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
    }
  );

  const selectAndUpload = (event) => {
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("mentorId", userId);
    event.target.value = null;
    event.target.files = null;

    uploadVideo({
      data: formData,
    });
  };

  return {
    deleteVideo,
    selectAndUpload,
    deleteVideoLoading,
    uploadVideoLoading,
  };
};
